import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importo le risorse di traduzione
import commonIT from '../locales/it/common.json';
import commonEN from '../locales/en/common.json';

const resources = {
  it: {
    common: commonIT
  },
  en: {
    common: commonEN
  }
};

// Array di callback da chiamare quando cambia la lingua
const languageChangeCallbacks: (() => void)[] = [];

// Funzione per registrare un callback da chiamare quando cambia la lingua
export const onLanguageChange = (callback: () => void) => {
  languageChangeCallbacks.push(callback);
  return () => {
    const index = languageChangeCallbacks.indexOf(callback);
    if (index !== -1) {
      languageChangeCallbacks.splice(index, 1);
    }
  };
};

i18n
  // Rileva automaticamente la lingua del browser
  .use(LanguageDetector)
  // Integrazione con React
  .use(initReactI18next)
  // Inizializza i18next
  .init({
    resources,
    // Lingua predefinita
    fallbackLng: 'it',
    // Namespace predefinito
    defaultNS: 'common',
    // Debug in ambiente di sviluppo
    debug: process.env.NODE_ENV === 'development',
    // Opzioni di interpolazione
    interpolation: {
      // Non serve escapare i valori in React
      escapeValue: false
    },
    // Rilevamento lingua
    detection: {
      // Ordine dei metodi di rilevamento
      order: ['localStorage', 'navigator'],
      // Salva la lingua nel localStorage
      caches: ['localStorage'],
      // Chiave utilizzata nel localStorage
      lookupLocalStorage: 'i18nextLng'
    }
  });

// Aggiungi un listener per il cambio di lingua
i18n.on('languageChanged', () => {
  // Notifica tutti i callback registrati
  languageChangeCallbacks.forEach(callback => callback());
});

export default i18n; 